import { render } from "./ThirdBar.vue?vue&type=template&id=70e9212a&scoped=true"
import script from "./ThirdBar.vue?vue&type=script&lang=js"
export * from "./ThirdBar.vue?vue&type=script&lang=js"

import "./ThirdBar.vue?vue&type=style&index=0&id=70e9212a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e9212a"]])

export default __exports__